const MobileMenuBtn = ({ menu, setMenu }) => {
  const genericHamburgerLine = `h-1 w-full my-1 rounded-full bg-primary
      transition ease transform duration-300`;
  return (
    <button
      aria-label="Open Menu"
      className="flex flex-col ml-2 scale-90 h-9 w-[30px] justify-center items-center group"
      onClick={() => setMenu(!menu)}
    >
      <div
        className={`${genericHamburgerLine} ${
          menu
            ? "rotate-45 translate-y-3 "
            : ""
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          menu ? "opacity-0" : ""
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          menu
            ? "-rotate-45 -translate-y-3 "
            : ""
        }`}
      />
    </button>
  );
};

export default MobileMenuBtn;
